import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import Logo from "../../assets/mesha-logo.png";
import {
  SettingOutlined,
  UserOutlined,
  TabletOutlined ,
  ProjectOutlined,
  AppstoreAddOutlined,
  DashboardOutlined,
  TeamOutlined,
  IdcardOutlined ,
    ThunderboltOutlined,
} from "@ant-design/icons";
import storePersist from "@/redux/storePersist";

const { Sider } = Layout;

const menuItems = [
  {
    key: "1",
    icon: <DashboardOutlined />,
    label: "Home Page",
    link: "/",
    roles: ["admin", "customer", "user"],
  },
  {
    key: "2",
    icon: <IdcardOutlined  />,
    label: "Customer",
    link: "/customer",
    roles: ["admin"],
  },
  {
    key: "11",
    icon: <TabletOutlined  />,
    label: "Dms",
    link: "/dms",
    roles: ["admin"],
  },
  {
    key: "21",
    icon: <UserOutlined />,
    label: "User",
    link: "/user",
    roles: ["admin", "customer"],
  },
  {
    key: "22",
    icon: <ProjectOutlined />,
    label: "Project View",
    link: "/projectview",
    roles: ["admin","customer"],
  },
  {
    key: "23",
    icon: <AppstoreAddOutlined  />,
    label: "Project Management",
    link: "/project",
    roles: ["admin","customer"],
  },
  {
    key: "31",
    icon: <TeamOutlined />,
    label: "Admins Management",
    link: "/admin",
    roles: ["admin"],
  },
  {
    key: "31b",
    icon: <AppstoreAddOutlined />,
    label: "Firmware Management",
    link: "/firmware",
    roles: ["admin"],
  },
  {
    key: "32",
    icon: <TeamOutlined />,
    label: "Charge/Discharge",
    link: "/cdcycle",
    roles: [],
  },
    {
    key: "35",
    icon: <TeamOutlined />,
    label: "Alert Log",
    link: "/alert",
    roles: [],
  },
  {
    key: "40",
    icon: <ThunderboltOutlined />,
    label: "Calibration",
    link: "/calibration",
    roles: ["admin"],
  },
  {
    key: "50",
    icon: <SettingOutlined />,
    label: "Settings",
    link: "/settings",
    roles: ["admin", "customer", "user"],
  },
];

function Navigation() {
  const [collapsed, setCollapsed] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const authData = storePersist.get("auth");
    console.log("Navidation authData", authData?.current);
    if (authData && authData?.current && authData?.current.role) {
      setUserRole(authData.current.role);
    }
  }, []);

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      style={{
        zIndex: 1000,
      }}
    >
            <img src={Logo} alt="logo" style={{height:"80px"}}/>
      <Menu theme="dark" defaultSelectedKeys={["1"]} mode="inline">
        {menuItems.map(
          (item) =>
            item.roles.includes(userRole) && (
              <Menu.Item key={item.key} icon={item.icon}>
                <Link to={item.link}>{item.label}</Link>
              </Menu.Item>
            )
        )}
      </Menu>
    </Sider>
  );
}

export default Navigation;